module.exports = __webpack_public_path__ + "static/media/tapari_taaa.c54c7d5b.ogg";